/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TodayPillarDto } from './TodayPillarDto';
import {
    TodayPillarDtoFromJSON,
    TodayPillarDtoFromJSONTyped,
    TodayPillarDtoToJSON,
    TodayPillarDtoToJSONTyped,
} from './TodayPillarDto';

/**
 * 
 * @export
 * @interface TodayPillarsResponseDto
 */
export interface TodayPillarsResponseDto {
    /**
     * 
     * @type {Array<TodayPillarDto>}
     * @memberof TodayPillarsResponseDto
     */
    pillars: Array<TodayPillarDto>;
}

/**
 * Check if a given object implements the TodayPillarsResponseDto interface.
 */
export function instanceOfTodayPillarsResponseDto(value: object): value is TodayPillarsResponseDto {
    if (!('pillars' in value) || value['pillars'] === undefined) return false;
    return true;
}

export function TodayPillarsResponseDtoFromJSON(json: any): TodayPillarsResponseDto {
    return TodayPillarsResponseDtoFromJSONTyped(json, false);
}

export function TodayPillarsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TodayPillarsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'pillars': ((json['pillars'] as Array<any>).map(TodayPillarDtoFromJSON)),
    };
}

export function TodayPillarsResponseDtoToJSON(json: any): TodayPillarsResponseDto {
    return TodayPillarsResponseDtoToJSONTyped(json, false);
}

export function TodayPillarsResponseDtoToJSONTyped(value?: TodayPillarsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pillars': ((value['pillars'] as Array<any>).map(TodayPillarDtoToJSON)),
    };
}

